let stylesInjected = false;

/** Shared CSS for table row links and card surface links (`data-surface-action`). Renders once per page load. */
export default function TableRowLinkTableStyles({
  wrapperClassName = "gt-table-row-link",
}: {
  wrapperClassName?: string;
}) {
  if (stylesInjected) return null;
  stylesInjected = true;

  return (
    <style>{`
      [data-surface-action] {
        position: relative;
        z-index: 2;
        pointer-events: auto;
      }
      .${wrapperClassName} tbody tr[data-row-link] {
        position: relative;
      }
      .${wrapperClassName} tbody tr[data-row-link] td[data-row-link-host] {
        position: relative;
        overflow: visible;
      }
      .${wrapperClassName} tbody tr[data-row-link] td[data-action-cell] {
        position: relative;
        z-index: 2;
      }
      .${wrapperClassName} tbody tr[data-row-link] td:not([data-action-cell]) > * {
        pointer-events: none;
      }
    `}</style>
  );
}
